// app/plugins/errorHandling.client.ts

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook("vue:error", error => {
    console.error("Error detected:", error);
    /*if (error.statusCode !== 404) {
      console.error(error);
      clearError();
    }*/
  });
});
